import "./ChangeCompanyInfoModal.scss"

import { MenuItem } from "@skylead/component-library"
import React from "react"
import { Dropdown } from "react-bootstrap"
import { useSelector } from "react-redux"

import getCountriesByLanguage from "../../../constants/countries"
import { useGlobalTranslation } from "../../../utils/hook"
import InputGroup from "../../organisms/InputGroup"
import LangText from "../LangText"

const ChangeCompanyInfoModal = ({ selectCountryOfIncorporation }) => {
  const { tt } = useGlobalTranslation()
  const [{ countryOfIncorporation }, formErrors, language] = useSelector(state => [
    state.forms.formData,
    state.forms.formErrors,
    state.user.profile.language,
  ])

  const countriesList = getCountriesByLanguage(language)
  const countryDropdownItems = countriesList.map(country => (
    <Dropdown.Item
      key={`country-${country.value}`}
      eventKey="1"
      onClick={() => {
        selectCountryOfIncorporation(country.value)
      }}
    >
      <MenuItem label={country.name} />
    </Dropdown.Item>
  ))

  return (
    <div className="change-company-modal-wrapper">
      <div className="change-company-modal-company-data">
        <div className="change-company-modal-company-data-description">
          <p>
            <LangText langKey="general" />
          </p>
          <p className="change-company-modal-company-data-explanation">
            <LangText langKey="change.company.info.modal.general.msg" />
          </p>
        </div>
        <div className="change-company-modal-company-data-inputs">
          <InputGroup
            field="companyName"
            label={tt("company-name")}
            message={formErrors?.companyName}
          />
          <InputGroup
            field="taxId"
            label={tt("tax-id-number")}
            placeholder={tt("company-name.placeholder")}
          />
        </div>
      </div>
      <div className="change-company-modal-company-adress">
        <div className="change-company-modal-company-adress-description">
          <p>
            <LangText langKey="address" />
          </p>
          <p className="change-company-modal-company-adress-explanation">
            <LangText langKey="change.company.info.modal.address.msg" />
          </p>
        </div>
        <div className="change-company-modal-company-adress-inputs">
          <InputGroup
            label={tt("country-of-incorporation")}
            placeholder={tt("choose-an-option")}
            type="select"
            isDropdownMenu
            dropdownSelectedItem={
              countriesList.find(option => option.value === countryOfIncorporation)?.name
            }
            customError={formErrors?.countryOfIncorporation}
            message={
              formErrors?.countryOfIncorporation
                ? tt("change.company.info.modal.country-of-incorporation.error.msg")
                : ""
            }
          >
            {countryDropdownItems}
          </InputGroup>
          <InputGroup
            field="companyAddress"
            label={tt("street-address")}
            message={formErrors?.companyAddress}
          />
          <InputGroup field="companyCity" label={tt("city")} message={formErrors?.companyCity} />
          <div className="state-inputs">
            <InputGroup
              field="companyState"
              label={tt("state")}
              message={formErrors?.companyState}
            />
            <InputGroup
              field="companyPostalCode"
              label={tt("postal-code")}
              placeholder={tt("company-postal-code.placeholder")}
              message={formErrors?.companyPostalCode}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangeCompanyInfoModal
